export default class PdpSteakTemperture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            steakTempValue: [],
            selectedModifierIdValue: -1,
            checked: false,
            description: ''
        }
        this.handleSteakTemp = this.handleSteakTemp.bind(this);
    }

    componentDidMount() {

        if (this.props.CartItem != null && this.props.CartItem.choices != null) {
            this.props.CartItem.choices.map((choice) => {
                this.props.data.Modifiers.map((item) => {
                    if (item.MenuItemDetail.Id == choice.optionid) {
                        this.handleSteakTemp(item.MenuItemDetail.Id, item.MenuItemDetail.Description);
                    }
                });
            });
        }

    }

    handleSteakTemp(selectedModifierIdValue, desc) {
        let index = desc.split("**").length;
        while (index != 1) {
            desc = desc.replace("**", "<span class='p1 bold'>");
            desc = desc.replace("**", "</span>");
            index = desc.split("**").length;
        }
        this.setState({ steakTempValue: selectedModifierIdValue, checked: true }, () => {
            $(".reqdText").text($(".reqdText").text().replace("(Required)", "Completed"));
            $(".reqdText").addClass("bold");
            console.log(this.state.steakTempValue, 'steakTempValueIdValue');
        })
        if (desc != null && desc != undefined) {
            let descriptionElement = document.getElementById("tempDescription");
            descriptionElement.innerHTML = "<span>" + desc + "</span>";
            descriptionElement.classList.remove("hidden");
        }
        this.props.handleSteakTempId(selectedModifierIdValue);
        if (this.props.CartItem != null && this.props.CartItem.choices != null) {
            //this.props.handleModalSelectedIds(selectedModifierIdValue);
        }
    }

    render() {
        const { data } = this.props;
        const { checked, steakTempValue } = this.state;
        return (
            <div className="SteakTempWrapper" id="steakTemp" >
                <div className="container-fluid">
                    <div className="row">
                        <div className="steakTitle">
                            <h5>{data.Name}</h5>
                            <p className="p2 reqdText" data-group-name={data.Name}>{(data.IsRequired === true) ? "(Required)" : "(Optional)"}</p>
                        </div>
                        <p className="p2">{this.props.SteakDescription}</p>
                        <div className="tempSelectWrapper">
                            {data.Modifiers.map((item) => {
                                return (
                                    <div className="tempSelect">
                                        <div className="imgWrapper form-check applebees-checkbox">
                                            <img alt={"clickable image " + item.MenuItemDetail.Name} src={item.MenuItemDetail.ImagePath}
                                                className={(checked == true && item.MenuItemDetail.Id === steakTempValue) ? "tempImg selectedImg" : "tempImg"}
                                                checked={checked}
                                                onClick={() => this.handleSteakTemp(item.MenuItemDetail.Id, item.MenuItemDetail.Description)}
                                                tabIndex="0" />
                                            {(checked == true && item.MenuItemDetail.Id === steakTempValue) ? <div><input className="rounded-circle form-check-input" type="radio" checked aria-label={item.MenuItemDetail.Name} tabIndex="0" /><label for="radioButton" className="d-none" aria-label="Radio" tabIndex="-1">Radio Button</label></div> : " "}
                                        </div>
                                        <p className="p2 bold tempName">{item.MenuItemDetail.Name}</p>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div aria-live="polite">
                            <div id="tempDescription" className="tempNameSelected p1 hidden">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
